import React, { useReducer, useState } from "react"
import PropTypes from "prop-types"
import Form from "react-bootstrap/Form"
import Button from "react-bootstrap/Button"
import Alerts from "../Alerts"
// Styles, images
import * as styles from "./Styles/SignupForm.module.scss"
import "../../styles/layouts"
import "../../styles/full_height"
import classNames from "classnames/bind"
const cn = classNames.bind(styles)
import logo from "../../images/logo_black.png"

const TERM_URL = "https://static.tokubai.co.jp/terms/locoguide.html"
const AGREEMENT_ON_PERSONAL_INFORMATION_URL = "https://static.tokubai.co.jp/terms/locoguide_agreement_on_personal_information.html"

const SignupForm = (props) => {
  const [user, dispatchUser] = useReducer(userReducer, props.user)
  const [submittable, setSubmittable] = useState(false)

  function userReducer(user, action) {
    switch (action.type) {
      case "email":
        return { ...user, email: action.value }
      case "password":
        return { ...user, password: action.value }
      case "password_confirmation":
        return { ...user, password_digest: action.value }
      default:
        return user
    }
  }

  return (
    <React.Fragment>
      <Alerts error={props.error} notice={props.notice} />
      <div className={cn("l-centering", "l-flex--column", "container")}>
        <img src={logo} alt="logo" className={styles.serviceLogo} />
        <Form action={props.formPath} method="post" className={styles.form}>
          <Form.Group controlId="signInForm.email">
            <Form.Label>メールアドレス</Form.Label>
            <Form.Control
              type="email"
              placeholder="name@example.com"
              name="email"
              value={user.email ? user.email : ""}
              onChange={(e) =>
                dispatchUser({ type: "email", value: e.target.value })
              }
            />
          </Form.Group>
          <Form.Group controlId="signInForm.password">
            <Form.Label>パスワード</Form.Label>
            <Form.Control
              type="password"
              placeholder="半角英数字記号 10文字以上"
              name="password"
              autoComplete="new-password"
              onChange={(e) =>
                dispatchUser({ type: "password", value: e.target.value })
              }
            />
          </Form.Group>
          <Form.Group controlId="signInForm.passwordConfirm">
            <Form.Label>パスワード（確認）</Form.Label>
            <Form.Control
              type="password"
              placeholder="パスワード再入力"
              name="password_confirmation"
              autoComplete="new-password"
              onChange={(e) =>
                dispatchUser({
                  type: "password_confirmation",
                  value: e.target.value,
                })
              }
            />
          </Form.Group>
          <Form.Group controlId="signInForm.checkbox">
            <Form.Check
                  type="checkbox"
                  label={
                    <div className={styles.agreementLabel}>
                      <a href={TERM_URL} target="_blank">利用規約</a>
                      と
                      <a href={AGREEMENT_ON_PERSONAL_INFORMATION_URL} target="_blank">個人情報の取扱いについて</a>
                      同意する
                    </div>
                    }
                  onChange={e => setSubmittable(e.target.checked)}
                  defaultChecked={false}
            />
          </Form.Group>
          <input type="hidden" name="authenticity_token" value={props.token} />
          <Button variant="primary" type="submit" className={styles.formButton} disabled={!submittable}>
            登録する
          </Button>
        </Form>
        <div className={styles.links}>
          <p>
            <a href={props.signinPath}>ログインはこちら</a>
          </p>
        </div>
      </div>
    </React.Fragment>
  )
}
SignupForm.propTypes = {
  user: PropTypes.object,
  formPath: PropTypes.string,
  signinPath: PropTypes.string,
  token: PropTypes.string,
  error: PropTypes.string,
  notice: PropTypes.string,
}
export default SignupForm
